/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AreaOfInterest } from '../models/area-of-interest';
import { changeDnaData } from '../fn/student-profile/change-dna-data';
import { ChangeDnaData$Params } from '../fn/student-profile/change-dna-data';
import { changeDnaLabel } from '../fn/student-profile/change-dna-label';
import { ChangeDnaLabel$Params } from '../fn/student-profile/change-dna-label';
import { CompanyMatchPagedData } from '../models/company-match-paged-data';
import { createEducation } from '../fn/student-profile/create-education';
import { CreateEducation$Params } from '../fn/student-profile/create-education';
import { createForeignExperience } from '../fn/student-profile/create-foreign-experience';
import { CreateForeignExperience$Params } from '../fn/student-profile/create-foreign-experience';
import { createInterest } from '../fn/student-profile/create-interest';
import { CreateInterest$Params } from '../fn/student-profile/create-interest';
import { createInternshipApplication } from '../fn/student-profile/create-internship-application';
import { CreateInternshipApplication$Params } from '../fn/student-profile/create-internship-application';
import { createLanguageProficiency } from '../fn/student-profile/create-language-proficiency';
import { CreateLanguageProficiency$Params } from '../fn/student-profile/create-language-proficiency';
import { createStudentProfile } from '../fn/student-profile/create-student-profile';
import { CreateStudentProfile$Params } from '../fn/student-profile/create-student-profile';
import { createStudentProfileSimple } from '../fn/student-profile/create-student-profile-simple';
import { CreateStudentProfileSimple$Params } from '../fn/student-profile/create-student-profile-simple';
import { createWorkExperience } from '../fn/student-profile/create-work-experience';
import { CreateWorkExperience$Params } from '../fn/student-profile/create-work-experience';
import { deleteCv } from '../fn/student-profile/delete-cv';
import { DeleteCv$Params } from '../fn/student-profile/delete-cv';
import { deleteDnaLabel } from '../fn/student-profile/delete-dna-label';
import { DeleteDnaLabel$Params } from '../fn/student-profile/delete-dna-label';
import { deleteEducation } from '../fn/student-profile/delete-education';
import { DeleteEducation$Params } from '../fn/student-profile/delete-education';
import { deleteForeignExperience } from '../fn/student-profile/delete-foreign-experience';
import { DeleteForeignExperience$Params } from '../fn/student-profile/delete-foreign-experience';
import { deleteInterest } from '../fn/student-profile/delete-interest';
import { DeleteInterest$Params } from '../fn/student-profile/delete-interest';
import { deleteLanguageProficiency } from '../fn/student-profile/delete-language-proficiency';
import { DeleteLanguageProficiency$Params } from '../fn/student-profile/delete-language-proficiency';
import { deleteStudentPlannedExperienceDay } from '../fn/student-profile/delete-student-planned-experience-day';
import { DeleteStudentPlannedExperienceDay$Params } from '../fn/student-profile/delete-student-planned-experience-day';
import { deleteStudentPlannedFocusDay } from '../fn/student-profile/delete-student-planned-focus-day';
import { DeleteStudentPlannedFocusDay$Params } from '../fn/student-profile/delete-student-planned-focus-day';
import { deleteStudentProfile } from '../fn/student-profile/delete-student-profile';
import { DeleteStudentProfile$Params } from '../fn/student-profile/delete-student-profile';
import { deleteWorkExperience } from '../fn/student-profile/delete-work-experience';
import { DeleteWorkExperience$Params } from '../fn/student-profile/delete-work-experience';
import { Education } from '../models/education';
import { ExperienceDay } from '../models/experience-day';
import { ExperienceDayWaiter } from '../models/experience-day-waiter';
import { ForeignExperience } from '../models/foreign-experience';
import { getCompanyMatches } from '../fn/student-profile/get-company-matches';
import { GetCompanyMatches$Params } from '../fn/student-profile/get-company-matches';
import { getConfirmedCompanyMatches } from '../fn/student-profile/get-confirmed-company-matches';
import { GetConfirmedCompanyMatches$Params } from '../fn/student-profile/get-confirmed-company-matches';
import { getCurrentStudentDna } from '../fn/student-profile/get-current-student-dna';
import { GetCurrentStudentDna$Params } from '../fn/student-profile/get-current-student-dna';
import { getCurrentStudentProfile } from '../fn/student-profile/get-current-student-profile';
import { GetCurrentStudentProfile$Params } from '../fn/student-profile/get-current-student-profile';
import { getEducation } from '../fn/student-profile/get-education';
import { GetEducation$Params } from '../fn/student-profile/get-education';
import { getEducations } from '../fn/student-profile/get-educations';
import { GetEducations$Params } from '../fn/student-profile/get-educations';
import { getExperiencedayOppertunities } from '../fn/student-profile/get-experienceday-oppertunities';
import { GetExperiencedayOppertunities$Params } from '../fn/student-profile/get-experienceday-oppertunities';
import { getForeignExperience } from '../fn/student-profile/get-foreign-experience';
import { GetForeignExperience$Params } from '../fn/student-profile/get-foreign-experience';
import { getForeignExperiences } from '../fn/student-profile/get-foreign-experiences';
import { GetForeignExperiences$Params } from '../fn/student-profile/get-foreign-experiences';
import { getInterest } from '../fn/student-profile/get-interest';
import { GetInterest$Params } from '../fn/student-profile/get-interest';
import { getInterests } from '../fn/student-profile/get-interests';
import { GetInterests$Params } from '../fn/student-profile/get-interests';
import { getJobPostingMatches } from '../fn/student-profile/get-job-posting-matches';
import { GetJobPostingMatches$Params } from '../fn/student-profile/get-job-posting-matches';
import { getLanguageProficiencies } from '../fn/student-profile/get-language-proficiencies';
import { GetLanguageProficiencies$Params } from '../fn/student-profile/get-language-proficiencies';
import { getLanguageProficiency } from '../fn/student-profile/get-language-proficiency';
import { GetLanguageProficiency$Params } from '../fn/student-profile/get-language-proficiency';
import { getMeetDaysForStudent } from '../fn/student-profile/get-meet-days-for-student';
import { GetMeetDaysForStudent$Params } from '../fn/student-profile/get-meet-days-for-student';
import { getPublicCurrentStudentDna } from '../fn/student-profile/get-public-current-student-dna';
import { GetPublicCurrentStudentDna$Params } from '../fn/student-profile/get-public-current-student-dna';
import { getStudentAssignment } from '../fn/student-profile/get-student-assignment';
import { GetStudentAssignment$Params } from '../fn/student-profile/get-student-assignment';
import { getStudentAssignments } from '../fn/student-profile/get-student-assignments';
import { GetStudentAssignments$Params } from '../fn/student-profile/get-student-assignments';
import { getStudentDna } from '../fn/student-profile/get-student-dna';
import { GetStudentDna$Params } from '../fn/student-profile/get-student-dna';
import { getStudentDnaHistory } from '../fn/student-profile/get-student-dna-history';
import { GetStudentDnaHistory$Params } from '../fn/student-profile/get-student-dna-history';
import { getStudentExeperienceDayWaitlist } from '../fn/student-profile/get-student-exeperience-day-waitlist';
import { GetStudentExeperienceDayWaitlist$Params } from '../fn/student-profile/get-student-exeperience-day-waitlist';
import { getStudentInternshipApplication } from '../fn/student-profile/get-student-internship-application';
import { GetStudentInternshipApplication$Params } from '../fn/student-profile/get-student-internship-application';
import { getStudentInternshipApplications } from '../fn/student-profile/get-student-internship-applications';
import { GetStudentInternshipApplications$Params } from '../fn/student-profile/get-student-internship-applications';
import { getStudentJobApplication } from '../fn/student-profile/get-student-job-application';
import { GetStudentJobApplication$Params } from '../fn/student-profile/get-student-job-application';
import { getStudentJobApplications } from '../fn/student-profile/get-student-job-applications';
import { GetStudentJobApplications$Params } from '../fn/student-profile/get-student-job-applications';
import { getStudentPlannedExperienceDay } from '../fn/student-profile/get-student-planned-experience-day';
import { GetStudentPlannedExperienceDay$Params } from '../fn/student-profile/get-student-planned-experience-day';
import { getStudentPlannedExperienceDays } from '../fn/student-profile/get-student-planned-experience-days';
import { GetStudentPlannedExperienceDays$Params } from '../fn/student-profile/get-student-planned-experience-days';
import { getStudentPlannedFocusDay } from '../fn/student-profile/get-student-planned-focus-day';
import { GetStudentPlannedFocusDay$Params } from '../fn/student-profile/get-student-planned-focus-day';
import { getStudentPlannedFocusDays } from '../fn/student-profile/get-student-planned-focus-days';
import { GetStudentPlannedFocusDays$Params } from '../fn/student-profile/get-student-planned-focus-days';
import { getStudentProfile } from '../fn/student-profile/get-student-profile';
import { GetStudentProfile$Params } from '../fn/student-profile/get-student-profile';
import { getStudentProfileAreaOfInterests } from '../fn/student-profile/get-student-profile-area-of-interests';
import { GetStudentProfileAreaOfInterests$Params } from '../fn/student-profile/get-student-profile-area-of-interests';
import { getStudentProfileCv } from '../fn/student-profile/get-student-profile-cv';
import { GetStudentProfileCv$Params } from '../fn/student-profile/get-student-profile-cv';
import { getStudentProfileMatchTestItems } from '../fn/student-profile/get-student-profile-match-test-items';
import { GetStudentProfileMatchTestItems$Params } from '../fn/student-profile/get-student-profile-match-test-items';
import { getStudentProfiles } from '../fn/student-profile/get-student-profiles';
import { GetStudentProfiles$Params } from '../fn/student-profile/get-student-profiles';
import { getStudentProfilesForSchoolClass } from '../fn/student-profile/get-student-profiles-for-school-class';
import { GetStudentProfilesForSchoolClass$Params } from '../fn/student-profile/get-student-profiles-for-school-class';
import { getWorkExperience } from '../fn/student-profile/get-work-experience';
import { GetWorkExperience$Params } from '../fn/student-profile/get-work-experience';
import { getWorkExperiences } from '../fn/student-profile/get-work-experiences';
import { GetWorkExperiences$Params } from '../fn/student-profile/get-work-experiences';
import { importProfileUsingDocument } from '../fn/student-profile/import-profile-using-document';
import { ImportProfileUsingDocument$Params } from '../fn/student-profile/import-profile-using-document';
import { Interests } from '../models/interests';
import { InternshipApplication } from '../models/internship-application';
import { JobApplication } from '../models/job-application';
import { JobMatchPagedData } from '../models/job-match-paged-data';
import { LanguageProficiency } from '../models/language-proficiency';
import { MatchTestItem } from '../models/match-test-item';
import { MeetDayPagedData } from '../models/meet-day-paged-data';
import { PlannedExperienceDay } from '../models/planned-experience-day';
import { PlannedExperienceDayPagedData } from '../models/planned-experience-day-paged-data';
import { PlannedFocusDay } from '../models/planned-focus-day';
import { PlannedFocusDayPagedData } from '../models/planned-focus-day-paged-data';
import { PublicStudentProfile } from '../models/public-student-profile';
import { registerStudentProfile } from '../fn/student-profile/register-student-profile';
import { RegisterStudentProfile$Params } from '../fn/student-profile/register-student-profile';
import { resendParentalConsentMessage } from '../fn/student-profile/resend-parental-consent-message';
import { ResendParentalConsentMessage$Params } from '../fn/student-profile/resend-parental-consent-message';
import { sendCvToCompany } from '../fn/student-profile/send-cv-to-company';
import { SendCvToCompany$Params } from '../fn/student-profile/send-cv-to-company';
import { setParentalConsent } from '../fn/student-profile/set-parental-consent';
import { SetParentalConsent$Params } from '../fn/student-profile/set-parental-consent';
import { setStudentProfileAreaOfInterest } from '../fn/student-profile/set-student-profile-area-of-interest';
import { SetStudentProfileAreaOfInterest$Params } from '../fn/student-profile/set-student-profile-area-of-interest';
import { startActualisationNotification } from '../fn/student-profile/start-actualisation-notification';
import { StartActualisationNotification$Params } from '../fn/student-profile/start-actualisation-notification';
import { StudentProfile } from '../models/student-profile';
import { StudentProfileAssignment } from '../models/student-profile-assignment';
import { StudentProfileDna } from '../models/student-profile-dna';
import { StudentProfilePagedData } from '../models/student-profile-paged-data';
import { transferToMty } from '../fn/student-profile/transfer-to-mty';
import { TransferToMty$Params } from '../fn/student-profile/transfer-to-mty';
import { updateEducation } from '../fn/student-profile/update-education';
import { UpdateEducation$Params } from '../fn/student-profile/update-education';
import { updateForeignExperience } from '../fn/student-profile/update-foreign-experience';
import { UpdateForeignExperience$Params } from '../fn/student-profile/update-foreign-experience';
import { updateInterest } from '../fn/student-profile/update-interest';
import { UpdateInterest$Params } from '../fn/student-profile/update-interest';
import { updateLanguageProficiency } from '../fn/student-profile/update-language-proficiency';
import { UpdateLanguageProficiency$Params } from '../fn/student-profile/update-language-proficiency';
import { updatePublicStatusStudentProfileCv } from '../fn/student-profile/update-public-status-student-profile-cv';
import { UpdatePublicStatusStudentProfileCv$Params } from '../fn/student-profile/update-public-status-student-profile-cv';
import { updateStudentProfile } from '../fn/student-profile/update-student-profile';
import { UpdateStudentProfile$Params } from '../fn/student-profile/update-student-profile';
import { updateStudentProfileMatchTestItems } from '../fn/student-profile/update-student-profile-match-test-items';
import { UpdateStudentProfileMatchTestItems$Params } from '../fn/student-profile/update-student-profile-match-test-items';
import { updateWorkExperience } from '../fn/student-profile/update-work-experience';
import { UpdateWorkExperience$Params } from '../fn/student-profile/update-work-experience';
import { uploadCv } from '../fn/student-profile/upload-cv';
import { UploadCv$Params } from '../fn/student-profile/upload-cv';
import { uploadStudentAssignmentDocument } from '../fn/student-profile/upload-student-assignment-document';
import { UploadStudentAssignmentDocument$Params } from '../fn/student-profile/upload-student-assignment-document';
import { WorkExperience } from '../models/work-experience';

@Injectable({ providedIn: 'root' })
export class StudentProfileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createStudentProfileSimple()` */
  static readonly CreateStudentProfileSimplePath = '/studentprofile/simple';

  /**
   * Creates a new student profile without any extra validation or email notifications [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStudentProfileSimple()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createStudentProfileSimple$Response(params?: CreateStudentProfileSimple$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = createStudentProfileSimple(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile without any extra validation or email notifications [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStudentProfileSimple$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createStudentProfileSimple(params?: CreateStudentProfileSimple$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.createStudentProfileSimple$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `getStudentProfiles()` */
  static readonly GetStudentProfilesPath = '/studentprofile';

  /**
   * Gets all student profiles [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfiles$Response(params?: GetStudentProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfilePagedData>> {
    const obs = getStudentProfiles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profiles [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfiles(params?: GetStudentProfiles$Params, context?: HttpContext): Observable<StudentProfilePagedData> {
    const resp = this.getStudentProfiles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfilePagedData>): StudentProfilePagedData => r.body)
    );
  }

  /** Path part for operation `createStudentProfile()` */
  static readonly CreateStudentProfilePath = '/studentprofile';

  /**
   * Creates a new student profile [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStudentProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createStudentProfile$Response(params?: CreateStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = createStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStudentProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createStudentProfile(params?: CreateStudentProfile$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.createStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `getStudentProfile()` */
  static readonly GetStudentProfilePath = '/studentprofile/{id}';

  /**
   * Gets the specified student profile [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfile$Response(params: GetStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = getStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfile(params: GetStudentProfile$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.getStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `updateStudentProfile()` */
  static readonly UpdateStudentProfilePath = '/studentprofile/{id}';

  /**
   * Updates the specified student profile [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStudentProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentProfile$Response(params: UpdateStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = updateStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStudentProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentProfile(params: UpdateStudentProfile$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.updateStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `deleteStudentProfile()` */
  static readonly DeleteStudentProfilePath = '/studentprofile/{id}';

  /**
   * Deletes the specified student profile [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStudentProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentProfile$Response(params: DeleteStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStudentProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentProfile(params: DeleteStudentProfile$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentProfileCv()` */
  static readonly GetStudentProfileCvPath = '/studentprofile/{studentId}/publiccv';

  /**
   * Returns the information for a student CV, if the student updated his or her CV to be public.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfileCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileCv$Response(params: GetStudentProfileCv$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicStudentProfile>> {
    const obs = getStudentProfileCv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Returns the information for a student CV, if the student updated his or her CV to be public.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfileCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileCv(params: GetStudentProfileCv$Params, context?: HttpContext): Observable<PublicStudentProfile> {
    const resp = this.getStudentProfileCv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PublicStudentProfile>): PublicStudentProfile => r.body)
    );
  }

  /** Path part for operation `updatePublicStatusStudentProfileCv()` */
  static readonly UpdatePublicStatusStudentProfileCvPath = '/studentprofile/{studentId}/publiccv/{shouldBePublic}';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePublicStatusStudentProfileCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePublicStatusStudentProfileCv$Response(params: UpdatePublicStatusStudentProfileCv$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicStudentProfile>> {
    const obs = updatePublicStatusStudentProfileCv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePublicStatusStudentProfileCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePublicStatusStudentProfileCv(params: UpdatePublicStatusStudentProfileCv$Params, context?: HttpContext): Observable<PublicStudentProfile> {
    const resp = this.updatePublicStatusStudentProfileCv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PublicStudentProfile>): PublicStudentProfile => r.body)
    );
  }

  /** Path part for operation `sendCvToCompany()` */
  static readonly SendCvToCompanyPath = '/studentprofile/{studentId}/publiccv/sendtocompany';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendCvToCompany()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendCvToCompany$Response(params: SendCvToCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = sendCvToCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendCvToCompany$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendCvToCompany(params: SendCvToCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.sendCvToCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCurrentStudentProfile()` */
  static readonly GetCurrentStudentProfilePath = '/studentprofile/current';

  /**
   * Gets the student profile for the currently logged in user [policies: Student].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentStudentProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentStudentProfile$Response(params?: GetCurrentStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = getCurrentStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the student profile for the currently logged in user [policies: Student].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentStudentProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentStudentProfile(params?: GetCurrentStudentProfile$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.getCurrentStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `registerStudentProfile()` */
  static readonly RegisterStudentProfilePath = '/studentprofile/register';

  /**
   * Registers a new student profile for the currently logged in user. [policies: Student].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerStudentProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerStudentProfile$Response(params?: RegisterStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = registerStudentProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Registers a new student profile for the currently logged in user. [policies: Student].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerStudentProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerStudentProfile(params?: RegisterStudentProfile$Params, context?: HttpContext): Observable<void> {
    const resp = this.registerStudentProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setParentalConsent()` */
  static readonly SetParentalConsentPath = '/studentprofile/{profileId}/parentalconsent';

  /**
   * Gives parental consent to the specified student profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setParentalConsent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setParentalConsent$Response(params: SetParentalConsent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setParentalConsent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gives parental consent to the specified student profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setParentalConsent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setParentalConsent(params: SetParentalConsent$Params, context?: HttpContext): Observable<void> {
    const resp = this.setParentalConsent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resendParentalConsentMessage()` */
  static readonly ResendParentalConsentMessagePath = '/studentprofile/{profileId}/resendparentalconsent';

  /**
   * Re-sends the email to the student's parent for consent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resendParentalConsentMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendParentalConsentMessage$Response(params: ResendParentalConsentMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resendParentalConsentMessage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Re-sends the email to the student's parent for consent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resendParentalConsentMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendParentalConsentMessage(params: ResendParentalConsentMessage$Params, context?: HttpContext): Observable<void> {
    const resp = this.resendParentalConsentMessage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `transferToMty()` */
  static readonly TransferToMtyPath = '/studentprofile/transfer';

  /**
   * Transfers the student profile to MTY.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferToMty()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  transferToMty$Response(params?: TransferToMty$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = transferToMty(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Transfers the student profile to MTY.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transferToMty$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  transferToMty(params?: TransferToMty$Params, context?: HttpContext): Observable<void> {
    const resp = this.transferToMty$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `startActualisationNotification()` */
  static readonly StartActualisationNotificationPath = '/studentprofile/startactualisationnotification';

  /**
   * Kicks off the ActualisationNotification mailing function [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startActualisationNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  startActualisationNotification$Response(params?: StartActualisationNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = startActualisationNotification(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Kicks off the ActualisationNotification mailing function [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startActualisationNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startActualisationNotification(params?: StartActualisationNotification$Params, context?: HttpContext): Observable<void> {
    const resp = this.startActualisationNotification$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentProfileAreaOfInterests()` */
  static readonly GetStudentProfileAreaOfInterestsPath = '/studentprofile/{profileId}/areaofinterest';

  /**
   * Gets all student profile area of interests [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfileAreaOfInterests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileAreaOfInterests$Response(params: GetStudentProfileAreaOfInterests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AreaOfInterest>>> {
    const obs = getStudentProfileAreaOfInterests(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile area of interests [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfileAreaOfInterests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileAreaOfInterests(params: GetStudentProfileAreaOfInterests$Params, context?: HttpContext): Observable<Array<AreaOfInterest>> {
    const resp = this.getStudentProfileAreaOfInterests$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AreaOfInterest>>): Array<AreaOfInterest> => r.body)
    );
  }

  /** Path part for operation `setStudentProfileAreaOfInterest()` */
  static readonly SetStudentProfileAreaOfInterestPath = '/studentprofile/{profileId}/areaofinterest';

  /**
   * Sets the student profile area of interests [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setStudentProfileAreaOfInterest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setStudentProfileAreaOfInterest$Response(params: SetStudentProfileAreaOfInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setStudentProfileAreaOfInterest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sets the student profile area of interests [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setStudentProfileAreaOfInterest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setStudentProfileAreaOfInterest(params: SetStudentProfileAreaOfInterest$Params, context?: HttpContext): Observable<void> {
    const resp = this.setStudentProfileAreaOfInterest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentAssignments()` */
  static readonly GetStudentAssignmentsPath = '/studentprofile/{profileId}/assignment';

  /**
   * Gets all student profile assignments [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentAssignments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentAssignments$Response(params: GetStudentAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentProfileAssignment>>> {
    const obs = getStudentAssignments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile assignments [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentAssignments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentAssignments(params: GetStudentAssignments$Params, context?: HttpContext): Observable<Array<StudentProfileAssignment>> {
    const resp = this.getStudentAssignments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<StudentProfileAssignment>>): Array<StudentProfileAssignment> => r.body)
    );
  }

  /** Path part for operation `getStudentAssignment()` */
  static readonly GetStudentAssignmentPath = '/studentprofile/{profileId}/assignment/{id}';

  /**
   * Gets the specified student profile assignment entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentAssignment$Response(params: GetStudentAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileAssignment>> {
    const obs = getStudentAssignment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile assignment entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentAssignment(params: GetStudentAssignment$Params, context?: HttpContext): Observable<StudentProfileAssignment> {
    const resp = this.getStudentAssignment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfileAssignment>): StudentProfileAssignment => r.body)
    );
  }

  /** Path part for operation `uploadStudentAssignmentDocument()` */
  static readonly UploadStudentAssignmentDocumentPath = '/studentprofile/{profileId}/assignment/{id}/document';

  /**
   * Uploads a document for the specified student profile assignment [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadStudentAssignmentDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadStudentAssignmentDocument$Response(params: UploadStudentAssignmentDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadStudentAssignmentDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Uploads a document for the specified student profile assignment [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadStudentAssignmentDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadStudentAssignmentDocument(params: UploadStudentAssignmentDocument$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadStudentAssignmentDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentDnaHistory()` */
  static readonly GetStudentDnaHistoryPath = '/studentprofile/{profileId}/dna';

  /**
   * Gets all student profile dna items [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentDnaHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentDnaHistory$Response(params: GetStudentDnaHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentProfileDna>>> {
    const obs = getStudentDnaHistory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile dna items [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentDnaHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentDnaHistory(params: GetStudentDnaHistory$Params, context?: HttpContext): Observable<Array<StudentProfileDna>> {
    const resp = this.getStudentDnaHistory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<StudentProfileDna>>): Array<StudentProfileDna> => r.body)
    );
  }

  /** Path part for operation `getStudentDna()` */
  static readonly GetStudentDnaPath = '/studentprofile/{profileId}/dna/{id}';

  /**
   * Gets the specified student profile dna entry [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentDna()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentDna$Response(params: GetStudentDna$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileDna>> {
    const obs = getStudentDna(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile dna entry [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentDna$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentDna(params: GetStudentDna$Params, context?: HttpContext): Observable<StudentProfileDna> {
    const resp = this.getStudentDna$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfileDna>): StudentProfileDna => r.body)
    );
  }

  /** Path part for operation `getCurrentStudentDna()` */
  static readonly GetCurrentStudentDnaPath = '/studentprofile/{profileId}/dna/current';

  /**
   * Gets the current student profile dna entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentStudentDna()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentStudentDna$Response(params: GetCurrentStudentDna$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileDna>> {
    const obs = getCurrentStudentDna(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the current student profile dna entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentStudentDna$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentStudentDna(params: GetCurrentStudentDna$Params, context?: HttpContext): Observable<StudentProfileDna> {
    const resp = this.getCurrentStudentDna$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfileDna>): StudentProfileDna => r.body)
    );
  }

  /** Path part for operation `getPublicCurrentStudentDna()` */
  static readonly GetPublicCurrentStudentDnaPath = '/public/studentprofile/{profileId}/dna/current';

  /**
   * Gets the student profile dna entry with API Key.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicCurrentStudentDna()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicCurrentStudentDna$Response(params: GetPublicCurrentStudentDna$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileDna>> {
    const obs = getPublicCurrentStudentDna(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the student profile dna entry with API Key.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicCurrentStudentDna$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicCurrentStudentDna(params: GetPublicCurrentStudentDna$Params, context?: HttpContext): Observable<StudentProfileDna> {
    const resp = this.getPublicCurrentStudentDna$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfileDna>): StudentProfileDna => r.body)
    );
  }

  /** Path part for operation `changeDnaLabel()` */
  static readonly ChangeDnaLabelPath = '/studentprofile/{profileId}/dna/{id}/label';

  /**
   * Change the Label for a dna entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeDnaLabel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeDnaLabel$Response(params: ChangeDnaLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = changeDnaLabel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change the Label for a dna entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeDnaLabel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeDnaLabel(params: ChangeDnaLabel$Params, context?: HttpContext): Observable<void> {
    const resp = this.changeDnaLabel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteDnaLabel()` */
  static readonly DeleteDnaLabelPath = '/studentprofile/{profileId}/dna/{id}/label';

  /**
   * Delete the Label for a dna entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDnaLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDnaLabel$Response(params: DeleteDnaLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteDnaLabel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete the Label for a dna entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDnaLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDnaLabel(params: DeleteDnaLabel$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteDnaLabel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeDnaData()` */
  static readonly ChangeDnaDataPath = '/studentprofile/{profileId}/dna/{id}/data';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeDnaData()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeDnaData$Response(params: ChangeDnaData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = changeDnaData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeDnaData$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeDnaData(params: ChangeDnaData$Params, context?: HttpContext): Observable<void> {
    const resp = this.changeDnaData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEducations()` */
  static readonly GetEducationsPath = '/studentprofile/{profileId}/education';

  /**
   * Gets all student profile education entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEducations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducations$Response(params: GetEducations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Education>>> {
    const obs = getEducations(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile education entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEducations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducations(params: GetEducations$Params, context?: HttpContext): Observable<Array<Education>> {
    const resp = this.getEducations$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Education>>): Array<Education> => r.body)
    );
  }

  /** Path part for operation `createEducation()` */
  static readonly CreateEducationPath = '/studentprofile/{profileId}/education';

  /**
   * Creates a new student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEducation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createEducation$Response(params: CreateEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<Education>> {
    const obs = createEducation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEducation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createEducation(params: CreateEducation$Params, context?: HttpContext): Observable<Education> {
    const resp = this.createEducation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Education>): Education => r.body)
    );
  }

  /** Path part for operation `getEducation()` */
  static readonly GetEducationPath = '/studentprofile/{profileId}/education/{id}';

  /**
   * Gets the specified student profile education entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEducation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducation$Response(params: GetEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<Education>> {
    const obs = getEducation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile education entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEducation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducation(params: GetEducation$Params, context?: HttpContext): Observable<Education> {
    const resp = this.getEducation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Education>): Education => r.body)
    );
  }

  /** Path part for operation `updateEducation()` */
  static readonly UpdateEducationPath = '/studentprofile/{profileId}/education/{id}';

  /**
   * Updates the specified student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEducation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEducation$Response(params: UpdateEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<Education>> {
    const obs = updateEducation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEducation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEducation(params: UpdateEducation$Params, context?: HttpContext): Observable<Education> {
    const resp = this.updateEducation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Education>): Education => r.body)
    );
  }

  /** Path part for operation `deleteEducation()` */
  static readonly DeleteEducationPath = '/studentprofile/{profileId}/education/{id}';

  /**
   * Deletes the specified student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEducation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEducation$Response(params: DeleteEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteEducation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile education entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEducation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEducation(params: DeleteEducation$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteEducation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getForeignExperiences()` */
  static readonly GetForeignExperiencesPath = '/studentprofile/{profileId}/foreignexperience';

  /**
   * Gets all student profile foreign experience entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getForeignExperiences()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForeignExperiences$Response(params: GetForeignExperiences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ForeignExperience>>> {
    const obs = getForeignExperiences(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile foreign experience entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getForeignExperiences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForeignExperiences(params: GetForeignExperiences$Params, context?: HttpContext): Observable<Array<ForeignExperience>> {
    const resp = this.getForeignExperiences$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ForeignExperience>>): Array<ForeignExperience> => r.body)
    );
  }

  /** Path part for operation `createForeignExperience()` */
  static readonly CreateForeignExperiencePath = '/studentprofile/{profileId}/foreignexperience';

  /**
   * Creates a new student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createForeignExperience()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createForeignExperience$Response(params: CreateForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<ForeignExperience>> {
    const obs = createForeignExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createForeignExperience$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createForeignExperience(params: CreateForeignExperience$Params, context?: HttpContext): Observable<ForeignExperience> {
    const resp = this.createForeignExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ForeignExperience>): ForeignExperience => r.body)
    );
  }

  /** Path part for operation `getForeignExperience()` */
  static readonly GetForeignExperiencePath = '/studentprofile/{profileId}/foreignexperience/{id}';

  /**
   * Gets the specified student profile foreign experience entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getForeignExperience()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForeignExperience$Response(params: GetForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<ForeignExperience>> {
    const obs = getForeignExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile foreign experience entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getForeignExperience$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForeignExperience(params: GetForeignExperience$Params, context?: HttpContext): Observable<ForeignExperience> {
    const resp = this.getForeignExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ForeignExperience>): ForeignExperience => r.body)
    );
  }

  /** Path part for operation `updateForeignExperience()` */
  static readonly UpdateForeignExperiencePath = '/studentprofile/{profileId}/foreignexperience/{id}';

  /**
   * Updates the specified student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateForeignExperience()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateForeignExperience$Response(params: UpdateForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<ForeignExperience>> {
    const obs = updateForeignExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateForeignExperience$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateForeignExperience(params: UpdateForeignExperience$Params, context?: HttpContext): Observable<ForeignExperience> {
    const resp = this.updateForeignExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ForeignExperience>): ForeignExperience => r.body)
    );
  }

  /** Path part for operation `deleteForeignExperience()` */
  static readonly DeleteForeignExperiencePath = '/studentprofile/{profileId}/foreignexperience/{id}';

  /**
   * Deletes the specified student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteForeignExperience()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteForeignExperience$Response(params: DeleteForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteForeignExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile foreign experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteForeignExperience$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteForeignExperience(params: DeleteForeignExperience$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteForeignExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getInterests()` */
  static readonly GetInterestsPath = '/studentprofile/{profileId}/interests';

  /**
   * Gets all student profile interests entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInterests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterests$Response(params: GetInterests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Interests>>> {
    const obs = getInterests(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile interests entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInterests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterests(params: GetInterests$Params, context?: HttpContext): Observable<Array<Interests>> {
    const resp = this.getInterests$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Interests>>): Array<Interests> => r.body)
    );
  }

  /** Path part for operation `createInterest()` */
  static readonly CreateInterestPath = '/studentprofile/{profileId}/interests';

  /**
   * Creates a new student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInterest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createInterest$Response(params: CreateInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<Interests>> {
    const obs = createInterest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInterest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createInterest(params: CreateInterest$Params, context?: HttpContext): Observable<Interests> {
    const resp = this.createInterest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Interests>): Interests => r.body)
    );
  }

  /** Path part for operation `getInterest()` */
  static readonly GetInterestPath = '/studentprofile/{profileId}/interests/{id}';

  /**
   * Gets the specified student profile interests entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInterest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterest$Response(params: GetInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<Interests>> {
    const obs = getInterest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile interests entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInterest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterest(params: GetInterest$Params, context?: HttpContext): Observable<Interests> {
    const resp = this.getInterest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Interests>): Interests => r.body)
    );
  }

  /** Path part for operation `updateInterest()` */
  static readonly UpdateInterestPath = '/studentprofile/{profileId}/interests/{id}';

  /**
   * Updates the specified student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInterest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateInterest$Response(params: UpdateInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<Interests>> {
    const obs = updateInterest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInterest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateInterest(params: UpdateInterest$Params, context?: HttpContext): Observable<Interests> {
    const resp = this.updateInterest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Interests>): Interests => r.body)
    );
  }

  /** Path part for operation `deleteInterest()` */
  static readonly DeleteInterestPath = '/studentprofile/{profileId}/interests/{id}';

  /**
   * Deletes the specified student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInterest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInterest$Response(params: DeleteInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteInterest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile interests entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteInterest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInterest(params: DeleteInterest$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteInterest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentInternshipApplications()` */
  static readonly GetStudentInternshipApplicationsPath = '/studentprofile/{profileId}/internshipapplications';

  /**
   * Gets all internship applications [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentInternshipApplications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentInternshipApplications$Response(params: GetStudentInternshipApplications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InternshipApplication>>> {
    const obs = getStudentInternshipApplications(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all internship applications [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentInternshipApplications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentInternshipApplications(params: GetStudentInternshipApplications$Params, context?: HttpContext): Observable<Array<InternshipApplication>> {
    const resp = this.getStudentInternshipApplications$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<InternshipApplication>>): Array<InternshipApplication> => r.body)
    );
  }

  /** Path part for operation `createInternshipApplication()` */
  static readonly CreateInternshipApplicationPath = '/studentprofile/{profileId}/internshipapplications';

  /**
   * Creates a new internship application [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInternshipApplication()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createInternshipApplication$Response(params: CreateInternshipApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<InternshipApplication>> {
    const obs = createInternshipApplication(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new internship application [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInternshipApplication$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createInternshipApplication(params: CreateInternshipApplication$Params, context?: HttpContext): Observable<InternshipApplication> {
    const resp = this.createInternshipApplication$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InternshipApplication>): InternshipApplication => r.body)
    );
  }

  /** Path part for operation `getStudentInternshipApplication()` */
  static readonly GetStudentInternshipApplicationPath = '/studentprofile/{profileId}/internshipapplications/{id}';

  /**
   * Gets the specified internship application [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentInternshipApplication()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentInternshipApplication$Response(params: GetStudentInternshipApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<InternshipApplication>> {
    const obs = getStudentInternshipApplication(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified internship application [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentInternshipApplication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentInternshipApplication(params: GetStudentInternshipApplication$Params, context?: HttpContext): Observable<InternshipApplication> {
    const resp = this.getStudentInternshipApplication$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InternshipApplication>): InternshipApplication => r.body)
    );
  }

  /** Path part for operation `getStudentJobApplications()` */
  static readonly GetStudentJobApplicationsPath = '/studentprofile/{profileId}/applications';

  /**
   * Gets all job applications [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentJobApplications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentJobApplications$Response(params: GetStudentJobApplications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<JobApplication>>> {
    const obs = getStudentJobApplications(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all job applications [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentJobApplications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentJobApplications(params: GetStudentJobApplications$Params, context?: HttpContext): Observable<Array<JobApplication>> {
    const resp = this.getStudentJobApplications$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<JobApplication>>): Array<JobApplication> => r.body)
    );
  }

  /** Path part for operation `getStudentJobApplication()` */
  static readonly GetStudentJobApplicationPath = '/studentprofile/{profileId}/applications/{id}';

  /**
   * Gets the specified job application [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentJobApplication()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentJobApplication$Response(params: GetStudentJobApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<JobApplication>> {
    const obs = getStudentJobApplication(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified job application [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentJobApplication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentJobApplication(params: GetStudentJobApplication$Params, context?: HttpContext): Observable<JobApplication> {
    const resp = this.getStudentJobApplication$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<JobApplication>): JobApplication => r.body)
    );
  }

  /** Path part for operation `getLanguageProficiencies()` */
  static readonly GetLanguageProficienciesPath = '/studentprofile/{profileId}/languageproficiency';

  /**
   * Gets all student profile language proficiency entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLanguageProficiencies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageProficiencies$Response(params: GetLanguageProficiencies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageProficiency>>> {
    const obs = getLanguageProficiencies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile language proficiency entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLanguageProficiencies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageProficiencies(params: GetLanguageProficiencies$Params, context?: HttpContext): Observable<Array<LanguageProficiency>> {
    const resp = this.getLanguageProficiencies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LanguageProficiency>>): Array<LanguageProficiency> => r.body)
    );
  }

  /** Path part for operation `createLanguageProficiency()` */
  static readonly CreateLanguageProficiencyPath = '/studentprofile/{profileId}/languageproficiency';

  /**
   * Creates a new student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLanguageProficiency()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createLanguageProficiency$Response(params: CreateLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageProficiency>> {
    const obs = createLanguageProficiency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLanguageProficiency$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createLanguageProficiency(params: CreateLanguageProficiency$Params, context?: HttpContext): Observable<LanguageProficiency> {
    const resp = this.createLanguageProficiency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LanguageProficiency>): LanguageProficiency => r.body)
    );
  }

  /** Path part for operation `getLanguageProficiency()` */
  static readonly GetLanguageProficiencyPath = '/studentprofile/{profileId}/languageproficiency/{id}';

  /**
   * Gets the specified student profile language proficiency entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLanguageProficiency()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageProficiency$Response(params: GetLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageProficiency>> {
    const obs = getLanguageProficiency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile language proficiency entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLanguageProficiency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageProficiency(params: GetLanguageProficiency$Params, context?: HttpContext): Observable<LanguageProficiency> {
    const resp = this.getLanguageProficiency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LanguageProficiency>): LanguageProficiency => r.body)
    );
  }

  /** Path part for operation `updateLanguageProficiency()` */
  static readonly UpdateLanguageProficiencyPath = '/studentprofile/{profileId}/languageproficiency/{id}';

  /**
   * Updates the specified student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLanguageProficiency()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateLanguageProficiency$Response(params: UpdateLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageProficiency>> {
    const obs = updateLanguageProficiency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLanguageProficiency$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateLanguageProficiency(params: UpdateLanguageProficiency$Params, context?: HttpContext): Observable<LanguageProficiency> {
    const resp = this.updateLanguageProficiency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LanguageProficiency>): LanguageProficiency => r.body)
    );
  }

  /** Path part for operation `deleteLanguageProficiency()` */
  static readonly DeleteLanguageProficiencyPath = '/studentprofile/{profileId}/languageproficiency/{id}';

  /**
   * Deletes the specified student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLanguageProficiency()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLanguageProficiency$Response(params: DeleteLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteLanguageProficiency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile language proficiency entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLanguageProficiency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLanguageProficiency(params: DeleteLanguageProficiency$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteLanguageProficiency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCompanyMatches()` */
  static readonly GetCompanyMatchesPath = '/studentprofile/{profileId}/match/company';

  /**
   * [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyMatches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyMatches$Response(params: GetCompanyMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyMatchPagedData>> {
    const obs = getCompanyMatches(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyMatches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyMatches(params: GetCompanyMatches$Params, context?: HttpContext): Observable<CompanyMatchPagedData> {
    const resp = this.getCompanyMatches$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CompanyMatchPagedData>): CompanyMatchPagedData => r.body)
    );
  }

  /** Path part for operation `getConfirmedCompanyMatches()` */
  static readonly GetConfirmedCompanyMatchesPath = '/studentprofile/{profileId}/match/company/confirmed';

  /**
   * [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfirmedCompanyMatches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfirmedCompanyMatches$Response(params: GetConfirmedCompanyMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyMatchPagedData>> {
    const obs = getConfirmedCompanyMatches(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfirmedCompanyMatches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfirmedCompanyMatches(params: GetConfirmedCompanyMatches$Params, context?: HttpContext): Observable<CompanyMatchPagedData> {
    const resp = this.getConfirmedCompanyMatches$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CompanyMatchPagedData>): CompanyMatchPagedData => r.body)
    );
  }

  /** Path part for operation `getJobPostingMatches()` */
  static readonly GetJobPostingMatchesPath = '/studentprofile/{profileId}/match/jobposting';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobPostingMatches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobPostingMatches$Response(params: GetJobPostingMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<JobMatchPagedData>> {
    const obs = getJobPostingMatches(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobPostingMatches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobPostingMatches(params: GetJobPostingMatches$Params, context?: HttpContext): Observable<JobMatchPagedData> {
    const resp = this.getJobPostingMatches$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<JobMatchPagedData>): JobMatchPagedData => r.body)
    );
  }

  /** Path part for operation `getStudentProfileMatchTestItems()` */
  static readonly GetStudentProfileMatchTestItemsPath = '/studentprofile/{profileId}/matchtest';

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfileMatchTestItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileMatchTestItems$Response(params: GetStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MatchTestItem>>> {
    const obs = getStudentProfileMatchTestItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfileMatchTestItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfileMatchTestItems(params: GetStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<Array<MatchTestItem>> {
    const resp = this.getStudentProfileMatchTestItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MatchTestItem>>): Array<MatchTestItem> => r.body)
    );
  }

  /** Path part for operation `updateStudentProfileMatchTestItems()` */
  static readonly UpdateStudentProfileMatchTestItemsPath = '/studentprofile/{profileId}/matchtest';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStudentProfileMatchTestItems()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentProfileMatchTestItems$Response(params: UpdateStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateStudentProfileMatchTestItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStudentProfileMatchTestItems$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentProfileMatchTestItems(params: UpdateStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateStudentProfileMatchTestItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMeetDaysForStudent()` */
  static readonly GetMeetDaysForStudentPath = '/studentprofile/{profileId}/meetday';

  /**
   * Gets all meet days for which the specified user has been registered.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDaysForStudent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDaysForStudent$Response(params: GetMeetDaysForStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayPagedData>> {
    const obs = getMeetDaysForStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all meet days for which the specified user has been registered.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDaysForStudent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDaysForStudent(params: GetMeetDaysForStudent$Params, context?: HttpContext): Observable<MeetDayPagedData> {
    const resp = this.getMeetDaysForStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayPagedData>): MeetDayPagedData => r.body)
    );
  }

  /** Path part for operation `getStudentPlannedExperienceDays()` */
  static readonly GetStudentPlannedExperienceDaysPath = '/studentprofile/{profileId}/plannedexperienceday';

  /**
   * Gets all planned experience days for this student profile [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentPlannedExperienceDays()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedExperienceDays$Response(params: GetStudentPlannedExperienceDays$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedExperienceDayPagedData>> {
    const obs = getStudentPlannedExperienceDays(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all planned experience days for this student profile [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentPlannedExperienceDays$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedExperienceDays(params: GetStudentPlannedExperienceDays$Params, context?: HttpContext): Observable<PlannedExperienceDayPagedData> {
    const resp = this.getStudentPlannedExperienceDays$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlannedExperienceDayPagedData>): PlannedExperienceDayPagedData => r.body)
    );
  }

  /** Path part for operation `getStudentPlannedExperienceDay()` */
  static readonly GetStudentPlannedExperienceDayPath = '/studentprofile/{profileId}/plannedexperienceday/{id}';

  /**
   * Gets the specified planned experience day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentPlannedExperienceDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedExperienceDay$Response(params: GetStudentPlannedExperienceDay$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedExperienceDay>> {
    const obs = getStudentPlannedExperienceDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified planned experience day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentPlannedExperienceDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedExperienceDay(params: GetStudentPlannedExperienceDay$Params, context?: HttpContext): Observable<PlannedExperienceDay> {
    const resp = this.getStudentPlannedExperienceDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlannedExperienceDay>): PlannedExperienceDay => r.body)
    );
  }

  /** Path part for operation `deleteStudentPlannedExperienceDay()` */
  static readonly DeleteStudentPlannedExperienceDayPath = '/studentprofile/{profileId}/plannedexperienceday/{id}';

  /**
   * Deletes the specified planned student experience day [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStudentPlannedExperienceDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentPlannedExperienceDay$Response(params: DeleteStudentPlannedExperienceDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteStudentPlannedExperienceDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified planned student experience day [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStudentPlannedExperienceDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentPlannedExperienceDay(params: DeleteStudentPlannedExperienceDay$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteStudentPlannedExperienceDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentExeperienceDayWaitlist()` */
  static readonly GetStudentExeperienceDayWaitlistPath = '/studentprofile/{profileId}/plannedexperienceday/waitlist';

  /**
   * Gets the experience days waitlist entries for student [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentExeperienceDayWaitlist()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentExeperienceDayWaitlist$Response(params: GetStudentExeperienceDayWaitlist$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExperienceDayWaiter>>> {
    const obs = getStudentExeperienceDayWaitlist(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the experience days waitlist entries for student [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentExeperienceDayWaitlist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentExeperienceDayWaitlist(params: GetStudentExeperienceDayWaitlist$Params, context?: HttpContext): Observable<Array<ExperienceDayWaiter>> {
    const resp = this.getStudentExeperienceDayWaitlist$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ExperienceDayWaiter>>): Array<ExperienceDayWaiter> => r.body)
    );
  }

  /** Path part for operation `getExperiencedayOppertunities()` */
  static readonly GetExperiencedayOppertunitiesPath = '/studentprofile/{profileId}/plannedexperienceday/oppertunities';

  /**
   * Gets experience days where student is on company experience day waitlist [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExperiencedayOppertunities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExperiencedayOppertunities$Response(params: GetExperiencedayOppertunities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExperienceDay>>> {
    const obs = getExperiencedayOppertunities(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets experience days where student is on company experience day waitlist [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExperiencedayOppertunities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExperiencedayOppertunities(params: GetExperiencedayOppertunities$Params, context?: HttpContext): Observable<Array<ExperienceDay>> {
    const resp = this.getExperiencedayOppertunities$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ExperienceDay>>): Array<ExperienceDay> => r.body)
    );
  }

  /** Path part for operation `getStudentPlannedFocusDays()` */
  static readonly GetStudentPlannedFocusDaysPath = '/studentprofile/{profileId}/plannedfocusday';

  /**
   * Gets all planned focus days for this student profile [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentPlannedFocusDays()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedFocusDays$Response(params: GetStudentPlannedFocusDays$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedFocusDayPagedData>> {
    const obs = getStudentPlannedFocusDays(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all planned focus days for this student profile [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentPlannedFocusDays$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedFocusDays(params: GetStudentPlannedFocusDays$Params, context?: HttpContext): Observable<PlannedFocusDayPagedData> {
    const resp = this.getStudentPlannedFocusDays$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlannedFocusDayPagedData>): PlannedFocusDayPagedData => r.body)
    );
  }

  /** Path part for operation `getStudentPlannedFocusDay()` */
  static readonly GetStudentPlannedFocusDayPath = '/studentprofile/{profileId}/plannedfocusday/{id}';

  /**
   * Gets the specified planned focus day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentPlannedFocusDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedFocusDay$Response(params: GetStudentPlannedFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedFocusDay>> {
    const obs = getStudentPlannedFocusDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified planned focus day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentPlannedFocusDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentPlannedFocusDay(params: GetStudentPlannedFocusDay$Params, context?: HttpContext): Observable<PlannedFocusDay> {
    const resp = this.getStudentPlannedFocusDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlannedFocusDay>): PlannedFocusDay => r.body)
    );
  }

  /** Path part for operation `deleteStudentPlannedFocusDay()` */
  static readonly DeleteStudentPlannedFocusDayPath = '/studentprofile/{profileId}/plannedfocusday/{id}';

  /**
   * Deletes the specified planned student focus day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStudentPlannedFocusDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentPlannedFocusDay$Response(params: DeleteStudentPlannedFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteStudentPlannedFocusDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified planned student focus day [policies: StudentOrTeacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStudentPlannedFocusDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStudentPlannedFocusDay(params: DeleteStudentPlannedFocusDay$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteStudentPlannedFocusDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentProfilesForSchoolClass()` */
  static readonly GetStudentProfilesForSchoolClassPath = '/schoolclass/{schoolClassId}/studentprofile';

  /**
   * Gets all student profiles for the given schoolclass [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentProfilesForSchoolClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfilesForSchoolClass$Response(params: GetStudentProfilesForSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfilePagedData>> {
    const obs = getStudentProfilesForSchoolClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profiles for the given schoolclass [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentProfilesForSchoolClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentProfilesForSchoolClass(params: GetStudentProfilesForSchoolClass$Params, context?: HttpContext): Observable<StudentProfilePagedData> {
    const resp = this.getStudentProfilesForSchoolClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfilePagedData>): StudentProfilePagedData => r.body)
    );
  }

  /** Path part for operation `uploadCv()` */
  static readonly UploadCvPath = '/studentprofile/{profileId}/cv';

  /**
   * Uploads a new CV document for the specified profile [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadCv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCv$Response(params: UploadCv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadCv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Uploads a new CV document for the specified profile [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadCv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCv(params: UploadCv$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadCv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCv()` */
  static readonly DeleteCvPath = '/studentprofile/{profileId}/cv/{id}';

  /**
   * Deletes the specified cv document [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCv$Response(params: DeleteCv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteCv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified cv document [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCv(params: DeleteCv$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteCv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importProfileUsingDocument()` */
  static readonly ImportProfileUsingDocumentPath = '/studentprofile/{profileId}/cv/import';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importProfileUsingDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importProfileUsingDocument$Response(params: ImportProfileUsingDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = importProfileUsingDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importProfileUsingDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importProfileUsingDocument(params: ImportProfileUsingDocument$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.importProfileUsingDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /** Path part for operation `getWorkExperiences()` */
  static readonly GetWorkExperiencesPath = '/studentprofile/{profileId}/workexperience';

  /**
   * Gets all student profile work experience entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkExperiences()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkExperiences$Response(params: GetWorkExperiences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkExperience>>> {
    const obs = getWorkExperiences(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all student profile work experience entries [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkExperiences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkExperiences(params: GetWorkExperiences$Params, context?: HttpContext): Observable<Array<WorkExperience>> {
    const resp = this.getWorkExperiences$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkExperience>>): Array<WorkExperience> => r.body)
    );
  }

  /** Path part for operation `createWorkExperience()` */
  static readonly CreateWorkExperiencePath = '/studentprofile/{profileId}/workexperience';

  /**
   * Creates a new student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkExperience()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkExperience$Response(params: CreateWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkExperience>> {
    const obs = createWorkExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkExperience$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkExperience(params: CreateWorkExperience$Params, context?: HttpContext): Observable<WorkExperience> {
    const resp = this.createWorkExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkExperience>): WorkExperience => r.body)
    );
  }

  /** Path part for operation `getWorkExperience()` */
  static readonly GetWorkExperiencePath = '/studentprofile/{profileId}/workexperience/{id}';

  /**
   * Gets the specified student profile work experience entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkExperience()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkExperience$Response(params: GetWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkExperience>> {
    const obs = getWorkExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified student profile work experience entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkExperience$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkExperience(params: GetWorkExperience$Params, context?: HttpContext): Observable<WorkExperience> {
    const resp = this.getWorkExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkExperience>): WorkExperience => r.body)
    );
  }

  /** Path part for operation `updateWorkExperience()` */
  static readonly UpdateWorkExperiencePath = '/studentprofile/{profileId}/workexperience/{id}';

  /**
   * Updates the specified student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkExperience()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkExperience$Response(params: UpdateWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkExperience>> {
    const obs = updateWorkExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkExperience$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkExperience(params: UpdateWorkExperience$Params, context?: HttpContext): Observable<WorkExperience> {
    const resp = this.updateWorkExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkExperience>): WorkExperience => r.body)
    );
  }

  /** Path part for operation `deleteWorkExperience()` */
  static readonly DeleteWorkExperiencePath = '/studentprofile/{profileId}/workexperience/{id}';

  /**
   * Deletes the specified student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkExperience()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkExperience$Response(params: DeleteWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteWorkExperience(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified student profile work experience entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkExperience$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkExperience(params: DeleteWorkExperience$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteWorkExperience$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
